import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { saveAppLanguage } from "./i18n/detectLanguage.js";
import "./LandingPage.css";

export default function LandingPage() {
  const { i18n } = useTranslation();

  const language = i18n.resolvedLanguage || i18n.language || "ru";
  const isEnglish = language.toLowerCase().startsWith("en");
  const changeLanguage = () => {
  const nextLanguage = isEnglish ? "ru" : "en";

  saveAppLanguage(nextLanguage);
  i18n.changeLanguage(nextLanguage);
};

  const [guide, setGuide] = useState(null);
const [menuOpen, setMenuOpen] = useState(false);

  const closeGuide = () => {
    setGuide(null);
  };

  return (
    <div className={`fit-landing ${isEnglish ? "fit-landing-en" : ""}`}>
      <div className="fit-landing-image-wrap">

<button
  type="button"
  className="fit-language-switch"
  aria-label="Переключить язык"
  onClick={changeLanguage}
>
  <span className={!isEnglish ? "active" : ""}>
    RU
  </span>

  <span className="separator">/</span>

  <span className={isEnglish ? "active" : ""}>
    EN
  </span>
</button>

        <img
          src={
  isEnglish
    ? "/landing/landing-design-hq-en.webp"
    : "/landing/landing-design-hq.webp"
}

          alt="FitMeUp"
          className="fit-landing-image"
        />

        <button
  type="button"
  className="fit-menu-open"
  aria-label="Открыть меню"
  onClick={() => setMenuOpen(true)}
/>

        {/* Android — верхняя кнопка */}
        <button
          type="button"
          className="fit-hotspot fit-android-top"
          aria-label="Установить FitMeUp на Android"
          onClick={() => setGuide("android")}
        />

        {/* iOS — верхняя кнопка */}
        <button
          type="button"
          className="fit-hotspot fit-ios-top"
          aria-label="Установить FitMeUp на iPhone"
          onClick={() => setGuide("ios")}
        />

        {/* Android — нижняя кнопка */}
        <button
          type="button"
          className="fit-hotspot fit-android-bottom"
          aria-label="Установить FitMeUp на Android"
          onClick={() => setGuide("android")}
        />

        {/* iOS — нижняя кнопка */}
        <button
          type="button"
          className="fit-hotspot fit-ios-bottom"
          aria-label="Установить FitMeUp на iPhone"
          onClick={() => setGuide("ios")}
        />
      </div>

      {guide && (
        <div
          className="fit-guide-overlay"
          role="dialog"
          aria-modal="true"
          aria-label={
            guide === "ios"
              ? "Установка FitMeUp на iPhone"
              : "Установка FitMeUp на Android"
          }
        >
          <div className="fit-guide-wrap">
            <img
src={
  guide === "ios"
    ? isEnglish
      ? "/landing/guide-ios-en.webp"
      : "/landing/guide-ios.webp"
    : isEnglish
      ? "/landing/guide-android-en.webp"
      : "/landing/guide-android.webp"
}
              alt=""
              className="fit-guide-image"
            />

            <button
              type="button"
              className="fit-guide-close"
              aria-label="Закрыть"
              onClick={closeGuide}
            />

            <button
              type="button"
              className="fit-guide-understood"
              aria-label="Понятно"
              onClick={closeGuide}
            />
          </div>
        </div>
      )}
      {menuOpen && (
  <div
    className="fit-menu-overlay"
    onClick={() => setMenuOpen(false)}
  >
    <div
      className="fit-menu-panel"
      onClick={(e) => e.stopPropagation()}
    >
      <img
        src={
  isEnglish
    ? "/landing/burger-menu-en.webp"
    : "/landing/burger-menu.webp"
}
        alt="Меню FitMeUp"
        className="fit-menu-image"
      />

      <button
        type="button"
        className="fit-menu-close"
        aria-label="Закрыть меню"
        onClick={() => setMenuOpen(false)}
      />

      <button
        type="button"
        className="fit-menu-food"
        aria-label="Питание"
        onClick={() => {
          setMenuOpen(false);
          window.scrollTo({
            top: document.body.scrollHeight * 0.28,
            behavior: "smooth",
          });
        }}
      />

      <button
        type="button"
        className="fit-menu-workout"
        aria-label="Тренировки"
        onClick={() => {
          setMenuOpen(false);
          window.scrollTo({
            top: document.body.scrollHeight * 0.51,
            behavior: "smooth",
          });
        }}
      />

      <button
        type="button"
        className="fit-menu-progress"
        aria-label="Прогресс"
        onClick={() => {
          setMenuOpen(false);
          window.scrollTo({
            top: document.body.scrollHeight * 0.72,
            behavior: "smooth",
          });
        }}
      />

      <button
        type="button"
        className="fit-menu-android"
        aria-label="Установить на Android"
        onClick={() => {
          setMenuOpen(false);
          setGuide("android");
        }}
      />

<button
  type="button"
  className="fit-menu-ios"
  aria-label="Установить на iOS"
  onClick={() => {
    setMenuOpen(false);
    setGuide("ios");
  }}
/>

<button
  type="button"
  className="fit-menu-support"
  aria-label="Поддержка"
  onClick={() => {
    setMenuOpen(false);
    window.location.href = "https://t.me/FitMeUp_support";
  }}
/>
    </div>
  </div>
)}
    </div>
  );
}